<template>
  <div class="has_market_price">
    <Header />
    <div class="container">
      <div class="row mt-3">
        <div class="col-lg-5 border border-dark rounded">
          <h5 class="text-center my-3">Forward Contracts</h5>
          <div class="pr-4 pt-2 text-center" style="height:auto;">
            <p>
              A forward contract or simply a forward is a non-standardized
              contract between two parties to buy or sell an asset at a
              specified future time at a price agreed on at the time of
              conclusion of the contract, making it a type of derivative
              instrument.
            </p>

            <p>
              The party agreeing to buy the underlying asset in the future
              assumes a long position, and the party agreeing to sell the asset
              in the future assumes a short position. The price agreed upon is
              called the delivery price, which is equal to the forward price at
              the time the contract is entered into.
            </p>

            <p>
              The price of the underlying instrument, in whatever form, is paid
              before control of the instrument changes. This is one of the many
              forms of buy/sell orders where the time and date of trade is not
              the same as the value date where the securities themselves are
              exchanged. Forwards, like other derivative securities, can be used
              to hedge risk (typically currency or exchange rate risk), as a
              means of speculation, or to allow a party to take advantage of a
              quality of the underlying instrument which is time-sensitive.
            </p>
          </div>
        </div>
        <div class="col-lg-6 ml-auto text-center">
          <div class="col-12">
            <h4 class="text-center my-3">Market Data - Insights</h4>
          </div>
          <div class="row">
            <div class="col-lg-6 h-100">
              <div class="img-section mb-4">
                <a href="javascript:void(0)" class="d-block">
                  <img
                    src="/assets/images/insights/stats.png"
                    class="img-fluid mb-1 d-block rounded-lg"
                    style="width: 263px; height: 166px; object-fill: cover"
                  />
                  <strong>Forward Contracts</strong>
                </a>
              </div>
              <div class="img-section mb-4">
                <a href="javascript:void(0)" class="d-block">
                  <img
                    src="/assets/images/insights/trades.png"
                    class="img-fluid mb-1 d-block rounded-lg"
                    style="width: 263px; height: 166px; object-fill: cover"
                  />
                  <strong> Futures trades and Spot trades </strong>
                </a>
              </div>
            </div>
            <div class="col-lg-6 h-100">
              <div class="img-section mb-4">
                <a href="javascript:void(0)" class="d-block">
                  <img
                    src="/assets/images/insights/analysis.png"
                    class="img-fluid mb-1 d-block rounded-lg"
                    style="width: 263px; height: 166px; object-fill: cover"
                  />
                  <strong>Data Analysis</strong>
                </a>
              </div>
              <div class="img-section mb-4">
                <a href="javascript:void(0)" class="d-block">
                  <img
                    src="/assets/images/insights/projections.png"
                    class="img-fluid mb-1 d-block rounded-lg"
                    style="width: 263px; height: 166px; object-fill: cover"
                  />
                  <strong>Quickleap Projectsion</strong>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    <market-price />
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MarketPrice from "@/components/MarketPrice";
// import { PerfectScrollbar } from "vue2-perfect-scrollbar";

export default {
  metaInfo: {
    title: "Quickleap",
    titleTemplate: "%s | Market Insight",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },
  components: {
    Header,
    Footer,
    MarketPrice
    // PerfectScrollbar
  }
};
</script>
